import { NextPage } from 'next';
import Plans from 'src/apps/Payment/Plans';
import {
  getSharedServerSideProps,
  SharedServerSideProps,
} from 'src/utils/getSharedServerSideProps';
import { LocaleOverride } from 'src/components/LocaleOverride';

export const getServerSideProps = getSharedServerSideProps;

const Page: NextPage<SharedServerSideProps> = ({ locale, messages, ...rest }) => {
  return (
    <LocaleOverride locale={locale} messages={messages}>
      <Plans {...rest} />
    </LocaleOverride>
  );
};

export default Page;
